export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./competencies.vue?vue&type=template&id=2bca0841&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/competencies.vue?vue&type=template&id=2bca0841&
// module id = 1667
// module chunks = 0